<!-- ==========================================================================================
    File Name: settings.vue
    Description: Settings Page
========================================================================================== -->

<template>
        <div id="settings-page">
                <vx-card>
                        <!-- Personal Data -->
                        <div class="vx-row leading-loose mt-3">
                                <div class="vx-col w-full md:w-1/2">
                                        <h4>Configuraciones de Copropiedad</h4>
                                </div>
                        </div>
                        <vs-row vs-w="12">
                                <vs-col
                                        vs-align="center"
                                        vs-justify="center"
                                        vs-lg="3"
                                        vs-sm="12"
                                        vs-type="flex"
                                        vs-xs="12"
                                >
                                        <vs-upload
                                                :headers="headers"
                                                action="/api/settings/update/logo"
                                                automatic
                                                file-name="logo"
                                                limit="1"
                                                show-upload-button
                                                text="Actualizar Logo"
                                                text-max="Se han alcanzado el limite de archivos"
                                                @on-success="successUpload"
                                        />
                                </vs-col>
                                <vs-col vs-lg="9" vs-sm="12" vs-xs="12">
                                        <!-- Row -->
                                        <div class="vx-row leading-loose mt-3">
                                                <div class="vx-col w-full md:w-1/2">
                                                        <vs-input
                                                                v-model="settings.epaycoAPI.public"
                                                                class="w-full no-icon-border"
                                                                label="Epayco Public Key"
                                                                name="epayco-public-key"
                                                        />
                                                </div>
                                                <div class="vx-col w-full md:w-1/2">
                                                        <vs-input
                                                                v-model="settings.epaycoAPI.private"
                                                                class="w-full no-icon-border"
                                                                label="Epayco Private Key"
                                                                name="epayco-private-key"
                                                        />
                                                </div>
                                        </div>
                                        <!-- end row -->
                                        <!-- Row -->
                                        <div class="vx-row leading-loose mt-3">
                                                <div class="vx-col w-full md:w-1/6">
                                                        <vs-select
                                                                v-model="settings.intereses.enabled"
                                                                class="w-full select-large"
                                                                label="Intereses Habilitados"
                                                        >
                                                                <vs-select-item
                                                                        v-for="(item, index) in enabledOptions"
                                                                        :key="index"
                                                                        :text="item.text"
                                                                        :value="item.value"
                                                                />
                                                        </vs-select>
                                                </div>
                                                <div class="vx-col w-full md:w-1/6">
                                                        <vs-input
                                                                v-model="settings.intereses.percent"
                                                                class="w-full no-icon-border"
                                                                label="Intereses (Porcentaje)"
                                                                name="intereses"
                                                        />
                                                </div>
                                                <div class="vx-col w-full md:w-1/6">
                                                        <vs-select
                                                                v-model="settings.descuentos.enabled"
                                                                class="w-full select-large"
                                                                label="Descuentos Habilitados"
                                                        >
                                                                <vs-select-item
                                                                        v-for="(item, index) in enabledOptions"
                                                                        :key="index"
                                                                        :text="item.text"
                                                                        :value="item.value"
                                                                />
                                                        </vs-select>
                                                </div>
                                                <div class="vx-col w-full md:w-1/6">
                                                        <vs-input
                                                                v-model="settings.descuentos.percent"
                                                                class="w-full no-icon-border"
                                                                label="Descuento (Porcentaje)"
                                                                name="descuentos"
                                                        />
                                                </div>
                                                <div class="vx-col w-full md:w-1/6">
                                                        <label>Fecha inicial</label>
                                                        <flat-pickr
                                                                v-model="settings.fromDate"
                                                                :config="configFromdateTimePicker"
                                                                class="w-full select-large"
                                                                @on-change="onFromChange"
                                                        />
                                                </div>
                                                <div class="vx-col w-full md:w-1/6">
                                                        <label>Fecha final</label>
                                                        <flat-pickr
                                                                v-model="settings.toDate"
                                                                :config="configTodateTimePicker"
                                                                :disabled="isDisabled"
                                                                class="w-full select-large"
                                                                @on-change="onToChange"
                                                        />
                                                </div>
                                        </div>
                                        <!-- end row -->
                                </vs-col>
                        </vs-row>
                        <!-- start row -->
                        <vs-row class="mt-10" vs-justify="flex-end" vs-type="flex" vs-w="12">
                                <vs-col vs-align="center" vs-justify="center" vs-lg="2" vs-sm="12" vs-type="flex">
                                        <vs-button
                                                color="primary"
                                                icon="far fa-save"
                                                icon-pack="FA5"
                                                monday-first
                                                type="filled"
                                                @click="saveSettings()"
                                                >Actualizar</vs-button
                                        >
                                </vs-col>
                        </vs-row>
                        <!-- end row -->
                        <!-- end Personal Data -->
                </vx-card>
        </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { Spanish } from 'flatpickr/dist/l10n/es';

export default {
        components: {
                flatPickr,
        },
        data() {
                return {
                        configFromdateTimePicker: {
                                minDate: new Date().getMonth(),
                                maxDate: null,
                                locale: Spanish,
                        },
                        configTodateTimePicker: {
                                minDate: null,

                                locale: Spanish,
                        },
                        headers: {
                                Authorization: `Bearer ${this.$store.state.authToken}`,
                        },
                        data: {
                                algo: 'va aqui',
                        },
                        isDisabled: true,
                        settings: {
                                fromDate: new Date(),
                                toDate: null,
                                epaycoAPI: {
                                        public: '',
                                        private: '',
                                },
                                intereses: {
                                        percent: '',
                                        limitDay: 30,
                                        enabled: '',
                                },
                                descuentos: {
                                        percent: '',
                                        enabled: '',
                                },
                        },
                        enabledOptions: [{ text: 'Si', value: true }, { text: 'No', value: false }],
                };
        },
        computed: {},
        methods: {
                saveSettings() {
                        this.$store.dispatch('updateSettings', this.settings).then(() => {
                                this.$router.push('/');
                        });
                },
                successUpload() {
                        this.$vs.notify({
                                color: 'success',
                                title: 'Logo actualizado con exito',
                                text: '',
                        });
                },
                onFromChange(selectedDates, dateStr, instance) {
                        this.isDisabled = false;
                        this.$set(this.configTodateTimePicker, 'minDate', dateStr);
                },
                onToChange(selectedDates, dateStr, instance) {
                        console.log(dateStr);
                        this.$set(this.configFromdateTimePicker, 'maxDate', dateStr);
                },
        },
};
</script>
